import styled from "@emotion/styled";
import { Dialog, DialogContent } from "@mui/material";

export const ModalOverlay = styled(Dialog)`
    > div > .MuiBackdrop-root {
        background: rgba(0, 0, 0, 0.55);
        transition: opacity 160ms ease;
    }

    > div > .MuiPaper-root {
        margin: 32px;
        width: 100%;
        max-width: 600px;

        @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
            margin: 0;
            width: 100%;
            max-width: 100%;
            height: 100%;
            max-height: 100%;
            border-radius: 0;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            position: fixed;
        }
    }
`;

export const ModalBody = styled(DialogContent)`
    background-color: ${({ theme }) => theme.palette.primary.dark2};
    position: relative;
    padding: 20px 24px 48px;

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 16px;
        height: 100%;
    }
`;

export const ModalCloseButton = styled.button`
    position: absolute;
    top: 12px;
    right: 12px;
    width: 40px;
    height: 40px;
    border-radius: 10px;
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.72);
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    line-height: 1;
    z-index: 2;

    &:hover {
        background: rgba(255, 255, 255, 0.08);
        color: rgba(255, 255, 255, 0.92);
    }

    &:active {
        transform: translateY(1px);
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        top: 10px;
        right: 10px;
        width: 44px;
        height: 44px;
        font-size: 32px;
        border-radius: 12px;
    }
`;

export const ModalHeader = styled.div`
    position: relative;
    display: flex;
    align-items: center;
    min-height: 44px;
    margin-bottom: ${({ $marginBottom = 0 }) =>
            typeof $marginBottom === "number" ? `${$marginBottom}px` : $marginBottom};
`;

export const ModalHeaderTitle = styled.div`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: ${({ theme }) => theme.fontSizes.xlarge};
    font-weight: bold;
    color: ${({ theme }) => theme.colors.text.lightgrey};
    white-space: nowrap;
`;

export const ModalHeaderCloseButton = styled(ModalCloseButton)`
    position: static;
    right: auto;
    z-index: auto;
    flex-shrink: 0;
    margin-left: auto;
    align-self: center;
`;

export const TitleText = styled.div`
    font-size: 1.5rem;
    font-weight: bold;
    margin-right: 0.2rem;
    color: ${({ textColor }) => {
    switch (textColor) {
        case "grey":
            return "#AEAEB0";
        case "green":
            return "#40A31E";
        default:
            return "#fff";
    }
}};
`;
